import { Button, Dropdown, Modal, Row, Space, Typography } from "antd";
import { ColumnsType } from "antd/lib/table";
import "../styles.css";

const { Text } = Typography;

export interface DataType {
  id: number;
  name: string;
  image: string;
  managerImage: string;
  price: number;
  type?: "NORMAL" | "TIER";
  internationalPercentage?: number | null;
  sortOrder?: number | null;
  isActiveForAllAdmins: boolean;
}

const actionItems = (
  navigate: any,
  handleDelete: any,
  record: any,
  openModal: any,
  activateServiceTypeForAll: any,
  openDeactivateModal: any,
) => {
  const items = [
    {
      key: "1",
      label: <Text>Editar</Text>,
      onClick: () =>
        navigate(`/servicetypes/edit/${record.id}`, {
          replace: true,
        }),
    },
    {
      key: "2",
      label: <Text>Activar {record.name}</Text>,
      onClick: () => openModal(record.id),
    },
    {
      key: "3",
      label: (
        <Text>
          {record.isActiveForAllAdmins ? "Desactivar" : "Activar"}{" "}
          {record.name} para todos
        </Text>
      ),
      onClick: () =>
        activateServiceTypeForAll(record.id, record.isActiveForAllAdmins),
    },
  ];

  if ((record.type || "NORMAL") === "NORMAL") {
    items.push({
      key: "5",
      label: <Text>Desactivar {record.name} para usuarios especificos</Text>,
      onClick: () => openDeactivateModal(record.id),
    });
  }

  items.push({
    key: "4",
    label: <Text>Eliminar {record.name}</Text>,
    onClick: () => {
      Modal.confirm({
        title: "Estas seguro de eliminar este tipo de servicio?",
        content: `Se eliminara el tipo de servicio "${record.name}"`,
        okText: "Si",
        cancelText: "No",
        onOk: async () => {
          await handleDelete(record.id);
        },
      });
    },
  });

  return items;
};

export const columns = (
  navigate: any,
  handleDelete: any,
  openModal: any,
  activateServiceTypeForAll: any,
  openDeactivateModal: any,
): ColumnsType<DataType> => [
  {
    title: "ID",
    dataIndex: "id",
    sorter: false,
  },
  {
    title: "Nombre",
    sorter: false,
    dataIndex: "name",
  },
  {
    title: "Imagen",
    sorter: false,
    dataIndex: "image",
    render: (_, record) => (
      <Row>
        {record.image ? (
          <img
            className="image-container"
            src={record.image}
            alt="this is a test"
          />
        ) : (
          <Space className="image-container">Imagen no disponible</Space>
        )}
      </Row>
    ),
  },
  {
    title: "Imagen manager",
    sorter: false,
    dataIndex: "managerImage",
    render: (_, record) => (
      <Row>
        {record.managerImage ? (
          <img
            className="image-container"
            src={record.managerImage}
            alt="manager"
          />
        ) : (
          <Space className="image-container">Imagen no disponible</Space>
        )}
      </Row>
    ),
  },
  {
    title: "Precio",
    sorter: false,
    dataIndex: "price",
  },
  {
    title: "Tipo",
    sorter: false,
    dataIndex: "type",
    render: (_, record) =>
      String(record.type || "NORMAL").toUpperCase() === "TIER"
        ? "Tier"
        : "Normal",
  },
  {
    title: "% Internacional",
    sorter: false,
    dataIndex: "internationalPercentage",
    render: (_, record) => {
      const val = record.internationalPercentage ?? 100;
      return `${Number(val).toFixed(2)}%`;
    },
  },
  {
    title: "Orden",
    sorter: false,
    dataIndex: "sortOrder",
    render: (_, record) => record.sortOrder ?? "-",
  },
  {
    title: "Acciones",
    key: "action",
    render: (_, record) => (
      <Row>
        <Dropdown
          menu={{
            items: actionItems(
              navigate,
              handleDelete,
              record,
              openModal,
              activateServiceTypeForAll,
              openDeactivateModal,
            ),
          }}
          placement="bottom"
          arrow
        >
          <Button>Permisos</Button>
        </Dropdown>
      </Row>
    ),
  },
];
